import React, { useContext, useState } from "react";
import { get } from "lodash";
import { LoaderWrapper, PlanCards } from "../../../../../components";
import {
  distributionFormFields,
  getAdvancedPathWithParam,
  MANAGE_TRANSFER_ROUTES,
  MANAGE_CENSUS_ROUTES,
  manageDistributionFormNames,
} from "../../../../../utils";
import {
  useDeepEffect,
  useRequest,
  useRouterParams,
} from "../../../../../abstracts";
import ManageDistributionLayout from "../../../../../components/ManageDistributionLayout/ManageDistributionLayout";
import { Form, Formik } from "formik";
import { useHistory } from "react-router-dom";
import SourceCard from "../../../../../components/SourceCards/SourceCard";
import InvestmentDetails from "../TransferRequest/InvestmentDetail/InvestmentDetails";
import { isEmpty } from "lodash";
import {
  appLayoutStore,
  globalToastInfo,
  manageDistributionStore,
  saveRebalanceRequest,
  setManageDistributionToastInfo,
  setTransferRequestPageData,
} from "../../../../../contexts";
import {
  getCurrentHoldings,
  getRebalanceDetails,
} from "../../../../../services";

const initialValues = { isFutureContribution: false };

const RebalanceRequestContainer = (props) => {
  const history = useHistory();
  const { state, dispatch } = useContext(manageDistributionStore);
  const { dispatch: globalDispatch } = useContext(appLayoutStore);
  const { flow, censusId } = useRouterParams();
  const intCensusId = parseInt(censusId);
  const formName = manageDistributionFormNames.REBALANCE_REQUEST;
  const fields = distributionFormFields[formName];
  const [employeeImage, setEmployeeImage] = useState("");
  const [planDetails, setPlanDetails] = useState([]);
  const [rebalanceDetails, setRebalanceDetails] = useState({});
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedPlanData, setSelectedPlanData] = useState({});
  const [sourceData, setSourceData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const { response: rebalanceApiData, loading: loading } = useRequest({
    method: getRebalanceDetails,
    payload: censusId,
    defaultResponse: {},
  });

  const { response: planApiData, loading: loading1 } = useRequest({
    method: getCurrentHoldings,
    payload: censusId,
    defaultResponse: {},
  });

  useDeepEffect(() => {
    dispatch(
      setTransferRequestPageData({
        formName: "censusId",
        fieldData: censusId,
      })
    );
    let rebalanceData =
      !isEmpty(rebalanceApiData) && rebalanceApiData.rebalanceDetails;
    setPlanDetails(!isEmpty(planApiData) && planApiData.transferRequestDetails);
    setRebalanceDetails(rebalanceData);
    setSelectedPlan(
      !isEmpty(planApiData) && !isEmpty(rebalanceData)
        ? planApiData.transferRequestDetails
            .map((_) => _.planId)
            .indexOf(rebalanceData && rebalanceData.planId)
        : !isEmpty(planApiData) &&
          planApiData.transferRequestDetails.length === 1
        ? 0
        : null
    );
  }, [censusId, planApiData, rebalanceApiData]);

  useDeepEffect(() => {
    let planData = !isEmpty(planDetails) ? planDetails[selectedPlan] : {};
    setSelectedPlanData(planData);
    setSourceData(
      !isEmpty(planData) &&
        planData.transferSourceDetails.map((item) => {
          let isChecked =
            !isEmpty(rebalanceDetails) &&
            rebalanceDetails.rebalanceSourceDetails
              .map((_) => _.sourceId)
              .includes(item.sourceId);
          return { ...item, checked: isChecked, show: isChecked };
        })
    );
  }, [planDetails, rebalanceDetails, selectedPlan]);

  const formValues = !isEmpty(selectedPlanData)
    ? {
        id: get(rebalanceDetails, "id", 0),
        employeeId: intCensusId,
        planId: selectedPlanData.planId,
        planName: selectedPlanData.planName,
        accountBalance: selectedPlanData.accountBalance,
        vestedBalance: selectedPlanData.vestedBalance,
        rebalanceSourceDetails: selectedPlanData.transferSourceDetails.map(
          (itm) => {
            let data =
              !isEmpty(rebalanceDetails) &&
              get(
                rebalanceDetails.rebalanceSourceDetails.filter(
                  (_) => _.sourceId === itm.sourceId
                ),
                "0"
              );
            if (!isEmpty(data)) return data;
            else
              return (itm = {
                id: itm.id ? itm.id : 0,
                sourceId: itm.sourceId,
                sourceName: itm.sourceName,
                sourceBalance: itm.sourceBalance,
                rebalanceInvestmentDetails: itm.transferInvestmentDetails.map(
                  (item) => {
                    return (item = {
                      id: item.id ? item.id : 0,
                      investmentId: item.investmentId,
                      investmentName: item.investmentName,
                      amount: item.amount,
                      percentage: Number(item.percentage.toFixed(2)),
                    });
                  }
                ),
              });
          }
        ),
      }
    : {};

  const onChange = (idx) => {
    setSourceData(
      sourceData.map((item, i) => {
        if (i === idx) {
          return {
            ...item,
            checked: !item.checked,
            show: !item.checked ? false : true,
          };
        }
        return item;
      })
    );
  };

  const hideCard = (idx) => {
    setSourceData(
      sourceData.map((item, i) => {
        if (i === idx) {
          return { ...item, show: !item.show };
        }
        return item;
      })
    );
  };

  const getTransformedValues = (values, status) => {
    return {
      ...values,
      rebalanceStatus: status,
      rebalanceSourceDetails: values.rebalanceSourceDetails.filter(
        (item, index) => sourceData[index].checked
      ),
    };
  };

  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setSubmitting }
  ) => {
    setIsLoading(true);
    saveRebalanceRequest(getTransformedValues(values, 1), false, dispatch)
      .then((response) => {
        setIsLoading(false);
        if (response.isSuccessfull) {
          dispatch(
            setTransferRequestPageData({
              formName: "currentHoldings",
              fieldData: sourceData,
            })
          );
          dispatch(
            setTransferRequestPageData({
              formName: "rebalanceDetails",
              fieldData: response.rebalanceDetails,
            })
          );
          history.push(
            getAdvancedPathWithParam({
              path: `${MANAGE_TRANSFER_ROUTES.REBALANCE_SUMMARY}`,
              pathParam: [flow, censusId],
            })
          );
        } else {
          setSubmitting(false);
          for (var i = 0; i < response.errorMessages?.length; i++) {
            var _ = response.errorMessages[i];
            setFieldTouched(_.controlName, true);
            setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        //error
      });
  };

  const saveDraft = (values, { setSubmitting }) => {
    setSubmitting(true);
    setIsLoading(true);
    saveRebalanceRequest(getTransformedValues(values, 1), true, dispatch)
      .then((response) => {
        setIsLoading(false);
        if (response.isSuccessfull) {
          globalDispatch(
            globalToastInfo({
              showToast: true,
              toastMessage: "Request saved successfully",
            })
          );
          history.push(
            getAdvancedPathWithParam({
              path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
              pathParam: [flow, censusId],
            })
          );
        }
      })
      .catch((err) => {
        setIsLoading(false);
        //error
      });
  };

  return (
    <>
      <Formik
        initialValues={{ ...initialValues, ...formValues }}
        onSubmit={onFormSubmit}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formProps) => {
          const {
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            setTouched,
            values,
            setSubmitting,
            setFieldError,
            fieldValue,
            ...rest
          } = formProps;

          const buttons = [
            {
              label: "Save as Darft",
              variant: "link",
              onClick: () => saveDraft(values, { setSubmitting }),
            },
            {
              label: "Cancel",
              variant: "secondary",
              type: "button",
              onClick: () =>
                history.push(
                  getAdvancedPathWithParam({
                    path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
                    pathParam: [flow, censusId],
                  })
                ),
            },
            {
              label: "Next",
              variant: "primary",
              type: "submit",
              disabled:
                !isEmpty(sourceData) &&
                !sourceData.map((_) => _.checked).includes(true),
            },
          ];

          return (
            <Form onSubmit={handleSubmit}>
              <LoaderWrapper isLoading={isLoading || loading || loading1}>
                <ManageDistributionLayout
                  buttons={buttons}
                  layoutHeader="Rebalance request"
                  employeeImage={employeeImage}
                >
                  <div className="transfer-container">
                    <p className="ft-16 fw-500">Select a Plan</p>
                    <PlanCards
                      {...formProps}
                      plans={planApiData.transferRequestDetails}
                      fields={fields}
                      isTransfer={true}
                      disable={
                        get(rebalanceDetails, "rebalanceStatus") !== undefined
                      }
                      selectedPlan={selectedPlan}
                      setSelectedPlan={setSelectedPlan}
                    />
                    <p className="ft-16 fw-500">Sources</p>
                    <div className="d-flex">
                      <SourceCard
                        {...formProps}
                        data={sourceData}
                        onChange={onChange}
                      />
                    </div>
                    <InvestmentDetails
                      {...formProps}
                      data={sourceData}
                      hideCard={hideCard}
                      isRebalance={true}
                      isViewOnly={true}
                    />
                  </div>
                </ManageDistributionLayout>
              </LoaderWrapper>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};
export default RebalanceRequestContainer;
